import { FooterLinks } from '../../layouts/Footer';
import CartButton from '../../atoms/Buttons/CartButton';
import React from 'react';
import useStyle from './footer.style';
import { useMediaQuery } from 'hooks/useMediaQuery';

interface FooterProps {
  shopId?: string | null;
  isNotAuthorizedEleve?: boolean;
}

export const Footer = ({
  shopId,
  isNotAuthorizedEleve = false
}: FooterProps) => {
  const classes = useStyle({ shopId });
  const isTablet = useMediaQuery('tablet');
  return (
    <>
      {isTablet ? (
        <div className={classes.mobileFooter}>
          <FooterLinks />
        </div>
      ) : (
        <div className={classes.root}>
          <FooterLinks />
          {!isNotAuthorizedEleve && <CartButton shopId={shopId} />}
        </div>
      )}
    </>
  );
};
